<template>
  <avs-card>
    <template v-slot:title>
      <div class="col-12 mt-5">
        <v-toolbar class="mt-5 mb-5 custom-toolbar bgTable" elevation="0">
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-row>
                  <v-col cols="12" md="3">
                    <v-select
                      v-model="selectedShop"
                      :items="shops"
                      @change="getVoucher"
                      item-text="name"
                      item-value="id"
                      :label="$t('Site')"
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu v-model="menuStartDate" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="startDate" :label="$t('Date de début')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                      </template>
                      <v-date-picker v-model="startDate" @input="getVoucher"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-menu v-model="menuEndDate" :close-on-content-click="false" transition="scale-transition" min-width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="endDate" :label="$t('Date de fin')" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" />
                      </template>
                      <v-date-picker v-model="endDate" @input="getVoucher"></v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="12" md="3" class="d-flex justify-end">
                    <slot name="actions" v-bind:dataset="dataset" />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-toolbar>
      </div>
    </template>
    <template v-slot:content>
      <v-data-table
        class="ma-10 bgTable"
        :headers="headers"
        :no-data-text="$t('messages.information.no_data')"
        :items="dataset"
        :loading-text="$t('categories.cfsi.loading')"
        :no-results-text="$tc('categories.cfsi.name', 0)"
        :loading="loading"
        disable-pagination
        hide-default-footer
      >
        <template v-slot:item.purchase_amount="{ item }">
          {{ formatNumber(item.purchase_amount) }} XOF
        </template>
        <template v-slot:item.purchase_liters="{ item }">
          {{ formatNumber(item.purchase_liters) }}
        </template>
        <template v-slot:item.remaining_amount="{ item }">
          {{ formatNumber(item.remaining_amount) }}  XOF
        </template>
        <template v-slot:item.status="{ item }">
          <component :is="handleStatusComponent(item)" />
        </template>
        <template v-slot:item.vehicle_detail.driver_first_name="{ item }">
          {{ getDriverName(item) }}
        </template>
        <template v-slot:item.valid_until="{ item }">
          {{ toDatetime(item.valid_until) }}
        </template>
        <template v-slot:item.company_shop.name="{ item }">
          {{ locationName(item.company_shop) }}
        </template>

      </v-data-table>
      <avs-deleteDialog
        v-model="deleteDialogIsOpen"
        @cancel="handleCancel"
        @delete="handleDelete"
        resource="Bon d'achat"
      /> </template
  ></avs-card>
</template>

<script>
import { debounce, truncate } from "lodash";
// import _ from "lodash"
import CompanyVouchersService from "@/services/CompanyVouchersService";
import {ShopDetailService} from "@/services"
import { toDate, toDatetime } from "@/utils/datetime";
// import { Closed, Ongoing, Overdue, Pending } from "@/components/generics/status"

export default {
  name: "VouchersTableHistory",
  // components: { Closed, Ongoing, Overdue, Pending },
  props: {
    inspectionId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      selectedItem: null,
      search: "",
      loading: false,
      dataset: [],
      shops: [],            // 🆕 Liste des shops à afficher dans le select
      selectedShop: null,   // 🆕 ID du shop sélectionné
      startDate: null,      // 🆕 Date de début sélectionnée
      endDate: null,        // 🆕 Date de fin sélectionnée
      menuStartDate: false, // 🆕 Contrôle du menu de date de début
      menuEndDate: false,
      headers: [
        /*{
          text: this.$t("Entreprise"),
          value: "recipient_company.name",
        },*/
        {
          text: this.$t("Vehicule"),
          value: "vehicle_detail.registration_number",
        },
        {
          text: this.$t("Conducteur"),
          value: "vehicle_detail.driver_first_name",
        },
        {
          text: this.$t("Montant"),
          value: "purchase_amount", 
        },
        { text: this.$tc("Litre"), value: "purchase_liters", align: "center" },
        {
          text: this.$t("Restant (CFA)"),
          value: "remaining_amount",
        },
        {
          text: this.$t("Restant (L)"),
          value: "liter_remaining",
        },
        { text: this.$t("Date de fin"), value: "valid_until" },
        { text: this.$t("Site"), value: "company_shop.name" },
        { text: this.$t("Produit"), value: "company_product.name" },
      ],
      getVoucherDebounced: null,
    };
  },
  methods: {
    truncate,
    toDatetime,
    toDate,
    openItemUrl(item) {
      window.open(item.image	, "_blank"); // Ouvre l'URL dans un nouvel onglet
    },
    onSearchChange() {
      this.getVoucherDebounced();
    },
    getQueryParams() {
      return {
        search: this.search || undefined,
        start_date: this.startDate || undefined,
        end_date: this.endDate || undefined,
        shop: this.selectedShop || undefined,
      };
    },
    fetchShopTypes() {
      ShopDetailService.getAll(this).then(response => {
        const apiShops = response?.results || response || [];
        this.shops = [{ id: null, name: this.$t("Tout le réseau") }, ...apiShops];
        // this.shops = response
      })
    },
    getDriverName(item) {
      if (item.vehicle_detail && (item.vehicle_detail.driver_first_name || item.vehicle_detail.driver_last_name)) {
        let driverFirstName = item.vehicle_detail.driver_first_name ? item.vehicle_detail.driver_first_name : "";
        let driverLastName = item.vehicle_detail.driver_last_name ? item.vehicle_detail.driver_last_name : "";
        return `${driverFirstName} ${driverLastName}`.trim(); // Trim pour éviter les espaces en trop
      }
      return "N/A"; // Si aucune info, afficher "N/A"
    },
    isDisabled(item) {
      return item.purchase_amount !== item.remaining_amount || item.as_historied == true;
    },
    getToEditLink(item) {
      return {
        name: "VoucherCreateUpdate",
        params: { id: item.id },
      };
    },
    getVoucher() {
      let t = this;
      this.loading = true;
      const params = this.getQueryParams();
      CompanyVouchersService.getHistory(this, params, this.id)
        .then((r) => {
          t.dataset = r.results;
        })
        .catch((err) => {
          if (err.response && err.response.status === 403) {
            // alert("Access denied: You do not have permission to access this resource.")
            this.$store.commit("app/message", {
              msg: this.$t("messages.error.permission_denied"),
              color: "error",
            });
          }
        })
        .finally(() => {
          t.loading = false;
        });
    },
    // formatNumber(value) {
    //   if (!value) return "";
    //   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    // },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") return "";

      const number = parseFloat(value);
      if (isNaN(number)) return value;

      // Séparation partie entière et décimale
      const [intPart, decimalPart] = number.toFixed(2).split(".");
      const formattedInt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

      // Si les décimales sont différentes de "00", on les affiche
      return decimalPart !== "00" ? `${formattedInt},${decimalPart}` : formattedInt;
    },
    locationName(value) {
      if (!value) return "Tout le reseau";
      return value.name;
    },
    handleDelete(item) {
      CompanyVouchersService.remove(this, this.selectedItem.id).then((r) => {
        this.dataset = this.dataset.filter((e) => e.id !== this.selectedItem.id);
        this.$store.commit("app/message", {
          msg: this.$t("messages.success.deleted", {
            entity: this.$tc("Bon d'achat", 2),
          }),
          color: "success",
        });
      });
      this.deleteDialogIsOpen = false;
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true;
      this.selectedItem = item;
    },
    handleCancel() {
      this.deleteDialogIsOpen = false;
    },
    handleStatusComponent(task) {
      return task.status;
    },
    toEdit(item) {
      this.$router.push(this.getToEditLink(item));
    },
    isNCSigned(item) {
      return item.state === 4;
    },
  },
  mounted() {
    // Initialisation du debounce
    this.getVoucherDebounced = debounce(this.getVoucher, 500);
    this.getVoucher();
  },
  created() {
    this.fetchShopTypes();
  },
  computed: {
    id() {
      return this.inDialog ? this.inDialogParams?.id : this.$route.params.id || null
    }
  }
};
</script>

<style scoped>
.custom-toolbar >>> .v-toolbar__content {
  gap: 1rem;
}
</style>
